import styled from 'styled-components'

export const OnboardLocateYourRestaurantContainer = styled('div').attrs(
  () => ({}),
)(({ theme }) => ({
  paddingTop: '40px',
}))

